import React, {Fragment} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {Panel, ThemeContext} from '../';
import {
  browserListTitle,
  upgradeBrowserPanelTitle,
  upgradeBrowserPanelSubTitle,
} from '../../../configs/messages';

const UpgradeBrowsers = ({os: osName}) => {
  const platformsList = [
    {
      name: 'Android 4.1',
      link: 'https://www.android.com/',
      className: 'android',
    },
    {
      name: 'Windows 7',
      link: 'https://windows.microsoft.com/',
      className: 'windows',
    },
    {
      name: 'iOS 12',
      link: 'https://www.apple.com/ios/ios-12/',
      className: 'ios',
      subtitle: 'Devices older than iPad Air 2 may experience poor performance',
    },
    {
      name: 'macOS 10',
      link: 'https://www.apple.com/macos/',
      className: 'macos',
    },
  ];
  const browserList = [
    {
      name: 'Google Chrome 58',
      link: 'https://www.google.com/chrome/browser/desktop/',
      className: 'chrome',
      os: ['Android', 'Mac OS', 'Windows'],
    },
    {
      name: 'Mozilla Firefox 56',
      link: 'https://www.mozilla.org/firefox/new/',
      className: 'firefox',
      os: ['Mac OS', 'Windows'],
    },
    {
      name: 'Apple Safari 12',
      link: 'https://support.apple.com/downloads/safari',
      className: 'safari',
      os: ['iOS', 'Mac OS', 'Windows'],
    },
    {
      name: 'Opera 45',
      link: 'https://www.opera.com/ru/download',
      className: 'opera',
      os: ['Windows', 'Mac OS', 'Windows'],
    },
  ].filter(({os}) => os && os.includes(osName));

  const hasOptions = Boolean(osName);
  const panelTitle = hasOptions
    ? upgradeBrowserPanelTitle
    : upgradeBrowserPanelSubTitle;
  const panelSubtitle = hasOptions
    ? upgradeBrowserPanelSubTitle
    : false;

  return (
    <ThemeContext.Consumer>
      {template => (
        <Panel
          title={panelTitle}
          subtitle={panelSubtitle}
          headerSize="l"
        >
          {hasOptions && (
            <Fragment>
              <p className="browser-list-header">{browserListTitle(browserList.length)}</p>
              <div className="row row_center browser-list">
                {
                  browserList.map((browser) => {
                    const {className, name, link} = browser;
                    const classes = classNames(
                      'browser__icon',
                      {
                        [`browser__icon_${className}`]: Boolean(className),
                      }
                    );
                    return (
                      <div className="cell text-center browser" key={className}>
                        <span className={classes}/>
                        <div className="browser__name">{name}</div>
                        <a style={{backgroundColor: template.primaryColor}} className="button button_rounded button_primary button_size_l" href={link}>Download</a>
                      </div>
                    );
                  })
                }
              </div>
            </Fragment>
          )}
          <p className="browser-list-header">Use these platforms ... or newer</p>
          <div className="row row_center platform-list">
            {
              platformsList.map((device) => {
                const {className, name, link, subtitle} = device;
                const classes = classNames(
                  'platform__icon',
                  {
                    [`platform__icon_${className}`]: Boolean(className),
                  }
                );
                return (
                  <div className="cell text-center platform" key={className}>
                    <a className="button button_rounded button_size_l" href={link}>
                      <span className={classes}/>
                    </a>
                    <div className="browser__name">{name}</div>
                    {subtitle && (
                      <small>{subtitle}</small>
                    )}
                  </div>
                );
              })
            }
          </div>
        </Panel>
      )}
    </ThemeContext.Consumer>
  );
};

UpgradeBrowsers.propTypes = {
  os: PropTypes.string.isRequired,
  isPhone: PropTypes.bool.isRequired,
};

export default UpgradeBrowsers;
